import { newsCategories } from '../../../mocks/news';
import type { NewsCategory } from '../../../mocks/news';

const categoryIcons: Record<NewsCategory, string> = {
  '全部': 'ri-list-unordered',
  '公司公告': 'ri-megaphone-line',
  '產品資訊': 'ri-price-tag-3-line',
  '產業動態': 'ri-bar-chart-grouped-line',
};

interface Props {
  active: NewsCategory;
  counts: Record<string, number>;
  onChange: (cat: NewsCategory) => void;
}

export default function NewsTabs({ active, counts, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-2 mb-8">
      {newsCategories.map(cat => (
        <button
          key={cat}
          onClick={() => onChange(cat)}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-all cursor-pointer whitespace-nowrap
            ${active === cat
              ? 'bg-[#1a73b5] text-white'
              : 'bg-white border border-gray-200 text-gray-600 hover:border-[#1a73b5] hover:text-[#1a73b5]'
            }`}
        >
          <i className={`${categoryIcons[cat]} text-base`} />
          {cat}
          <span className={`text-xs px-1.5 py-0.5 rounded-full ml-0.5 ${active === cat ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-500'}`}>
            {counts[cat] ?? 0}
          </span>
        </button>
      ))}
    </div>
  );
}
